import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Input } from "@digital-services/ui";
import { isNotEmpty, isRegExMatch, useInput } from "@ds-cps/ui";

import { EMAIL_REGEXP } from "@utils/validator-helpers";

interface Props {
  label: string;
  value: string | undefined;
  placeholder: string;
  onInputChange?: (newValue: string, isValid: boolean) => void;
}

export const EmailSimpleField: FunctionComponent<Props> = props => {
  const { label, value, placeholder, onInputChange } = props;
  const { t: tCommon } = useTranslation();

  const {
    value: email,
    isValid,
    errorMessage,
    valueChangeHandler
  } = useInput(
    [
      // TBD refactor
      isNotEmpty(() =>
        tCommon("validation.string.not-empty", { fieldName: label })
      ),
      isRegExMatch(EMAIL_REGEXP, () =>
        tCommon("validation.string.invalid-email", {
          fieldName: label
        })
      )
    ],
    value
  );

  return (
    <Input
      autoComplete="email"
      data-testid="email-simple"
      id="emailSimple"
      type="text"
      label={label}
      placeholder={placeholder}
      error={!isValid}
      helperText={isValid ? undefined : errorMessage}
      value={email}
      onChange={event => {
        const { value, isValid } = valueChangeHandler(
          event.target.value.replace(" ", "")
        );
        if (onInputChange) {
          onInputChange(value, isValid);
        }
      }}
    />
  );
};
